import type { TODO } from "../util/types";
import PostDetail from "./PostDetail";

interface OrderLineItem {
  [key: string]: TODO;
}

export interface PostData {
  checksum?: string;
  courseName?: string;
  courseVideoPosterUrl?: string;
  documentPreviewData?: object | null;
  downloadUrl?: string;
  eventEndDateTimeMillis?: number;
  eventLocation?: string;
  eventStartDateTimeMillis?: number;
  fileSizeInBytes?: number;
  mimeType?: string;
  newsContent?: string;
  postDetail: PostDetail;
  repositoryId?: string | number;
  srcUrl?: string;
  createdByUserName?: string;
  orderAmount?: number;
  orderLineCount?: number;
  orderLineItems?: OrderLineItem[];
  orderStatus?: string;
  siteName?: string;
  orderDownloadFileSizeInBytes?: number;
  orderContent?: string;
}

class Post /*extends Refetch*/ {
  checksum?: string;
  courseName?: string;
  courseVideoPosterUrl?: string;
  documentPreviewData?: object | null;
  downloadUrl?: string;
  eventEndDateTimeMillis?: number;
  eventLocation?: string;
  eventStartDateTimeMillis?: number;
  fileSizeInBytes?: number;
  mimeType?: string;
  newsContent?: string;
  postDetail: PostDetail;
  repositoryId?: string | number;
  srcUrl?: string;
  createdByUserName?: string;
  orderAmount?: number;
  orderLineCount?: number;
  orderLineItems?: OrderLineItem[];
  orderStatus?: string;
  siteName?: string;
  orderDownloadFileSizeInBytes?: number;
  orderContent?: string;
  title?: string

  constructor(post: PostData) {
    // super();
    this.checksum = post?.checksum;
    this.courseName = post?.courseName;
    this.courseVideoPosterUrl = post?.courseVideoPosterUrl;
    this.documentPreviewData = post?.documentPreviewData ?? null;
    this.downloadUrl = post?.downloadUrl;
    this.eventEndDateTimeMillis = post?.eventEndDateTimeMillis;
    this.eventLocation = post?.eventLocation;
    this.eventStartDateTimeMillis = post?.eventStartDateTimeMillis;
    this.fileSizeInBytes = post?.fileSizeInBytes;
    this.mimeType = post?.mimeType;
    this.newsContent = post?.newsContent;
    this.postDetail = new PostDetail(post.postDetail);
    this.repositoryId = post?.repositoryId;
    this.srcUrl = post?.srcUrl;
    this.createdByUserName = post?.createdByUserName;
    this.orderAmount = post?.orderAmount;
    this.orderLineCount = post?.orderLineCount;
    this.orderLineItems = post?.orderLineItems;
    this.orderStatus = post?.orderStatus;
    this.siteName = post?.siteName;
    this.orderDownloadFileSizeInBytes = post?.orderDownloadFileSizeInBytes;
    this.orderContent = post?.orderContent;
  }

  // async refetch() {
  //   const piniaMember = useMemberPostStore();
  //   await piniaMember.getVersionPostDetail({
  //     postId: this.postDetail!.postId,
  //     version: this.postDetail!.version,
  //   });
  // }
}

export type PostInput = PostData;

export default Post;
